import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { UsuarioService } from '../services/service.index';
import { Usuario } from '../models/usuario.model';
import { ModalService } from '../services/modal.service';
import {NgForm} from '@angular/forms';
import Swal from 'sweetalert2';


declare function init_plugins();
declare const gapi: any;
//declare cosntswal:any;

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {

  username: string;
  recuerdame: boolean = false;
  loadRegister: boolean = false;
  showPassword: boolean = false;
  auth2: any;
  token:String="";

  // ---- Carousel ----
  activeScene: number = 0;
  isTransitioning: boolean = false;
  private _rotateInterval: any;
  readonly scenes = [
    { label: 'Factura Electrónica' },
    { label: 'Boleta de Venta'     },
    { label: 'Nota de Crédito'     },
    { label: 'Reporte Mensual'     },
  ];

  constructor(
    public router: Router,
    public _usuarioService: UsuarioService,
    public _modalRegister:ModalService,
  ) { }

  ngOnInit() {
    init_plugins();
    this.username = localStorage.getItem('username') || '';
    if ( this.username.length > 1 ) {
      this.recuerdame = true;
    }
    this.token = localStorage.getItem('token') || '';
    if (this.token) {
      this._usuarioService.estaLogueado().subscribe({
        next: () => this.router.navigate(['/facturador']),
        error: () => this._usuarioService.clearSessionStorage(true)
      });
    } else {
      this._usuarioService.clearSessionStorage(true);
    }
    this._startCarousel();
  }

  ngOnDestroy() {
    this._stopCarousel();
  }

  private _startCarousel() {
    this._rotateInterval = setInterval(() => {
      this._changeScene((this.activeScene + 1) % this.scenes.length);
    }, 4500);
  }

  private _stopCarousel() {
    if (this._rotateInterval) {
      clearInterval(this._rotateInterval);
      this._rotateInterval = null;
    }
  }

  private _changeScene(index: number) {
    if (this.isTransitioning) return;
    this.isTransitioning = true;
    setTimeout(() => {
      this.activeScene = index;
      this.isTransitioning = false;
    }, 380);
  }

  goToScene(index: number) {
    if (index === this.activeScene || this.isTransitioning) return;
    this._stopCarousel();
    this._changeScene(index);
    setTimeout(() => this._startCarousel(), 420);
  }

  pauseCarousel() {
    this._stopCarousel();
  }

  resumeCarousel() {
    if (!this._rotateInterval) {
      this._startCarousel();
    }
  }

  attachSignin( element ) {
    this.auth2.attachClickHandler( element, {}, (googleUser) => {
      // let profile = googleUser.getBasicProfile();
      let token = googleUser.getAuthResponse().id_token;
      this._usuarioService.loginGoogle( token )
              .subscribe( () => window.location.href = '#/facturador'  );
    });
  }


  ingresar( forma: NgForm) {
    this.loadRegister=true;
    if ( forma.invalid ) {
      this.loadRegister=false;
      return;
    }
    this.loadRegister=true;
    let usuario = new Usuario( null, forma.value.username, forma.value.password );

    this._usuarioService.loginAuth( usuario, forma.value.recuerdame )
                  .subscribe( res => {       
                    this.loadRegister=true;
                    this._usuarioService.setStorageToken( res.access_token );
                    this._usuarioService.retornaUsuario( usuario,res.access_token )
                    .subscribe( resobjuser => {    
                      this.loadRegister=true;
                      if(resobjuser.estado==1){

                      // var usuario={"_id":resobjuser.defaultObj.empresa.idempresa,"cuenta":resobjuser.defaultObj.empresa.idcuenta,"nombre":resobjuser.defaultObj.nombres,"username":resobjuser.defaultObj.username,"img":resobjuser.defaultObj.empresa.logo,"empresa":resobjuser.defaultObj.empresa,"lsEmpresas":resobjuser.defaultObj.lsEmpresasEmpleado}
                      var usuario={"_id":resobjuser.defaultObj.company.id_empresa,"nombre":resobjuser.defaultObj.name,"username":resobjuser.defaultObj.username,"empresa":resobjuser.defaultObj.company,"perfil":resobjuser.defaultObj.perfil,"lsEmpresas":resobjuser.defaultObj.lsCompanyUser}
                      this._usuarioService.setStorageUsuario(res.expires_in,usuario,res.access_token);

                      this.router.navigate(['/facturador']);
                      }else{
                        Swal.fire('Usuario sin permisos!', 'El usuario logueado no tiene permisos.', 'warning');
                        this._usuarioService.logout();
                        this.loadRegister=false;
                      }
                    },errObjUser => {
                      this.loadRegister=false;
                      // Clear the orphaned token so a page refresh doesn't auto-redirect
                      // to /facturador with an incomplete session (no user data in localStorage).
                      this._usuarioService.logout();
                      if(errObjUser.status==400||errObjUser.status==401){
                       Swal.fire('Credenciales invalidos!', 'Por favor, comprueba tu e-mail o contraseña.', 'warning');
                      } else if(errObjUser.status == 403) {
                       Swal.fire('Acceso denegado', 'Tu cuenta no tiene permisos para acceder o aún no está activa.', 'warning');
                      } else {
                       Swal.fire('No existe conexión!', 'Por favor, comuniquese con el gestor de su cuenta.', 'error');
                      }
                    });
                  },err => {
                    this.loadRegister=false;
                    if(err.status==400||err.status==401){
                     Swal.fire('Credenciales invalidos!', 'Por favor, comprueba tu e-mail o contraseña.', 'warning');
                    } else if (err.status == 403) {
                     Swal.fire('Acceso denegado', 'Tu cuenta no tiene permisos para acceder o aún no está activa.', 'warning');
                    }else{
                     Swal.fire('No existe conexión!', 'Por favor, comuniquese con el gestor de su cuenta.', 'error');
                    }
                  }
                  );
  }

  registrarUsuario(){
    this._modalRegister.mostrarModal();
  }

}
